import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import type { ComponentType } from 'react'

import Container from '@/legacy-src/rebrand/Container'

import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { HeaderMainNavigationContent } from '@/src/domains/header/components/Header/Header.constants'
import { getHeaderMainNavigationItems } from '@/src/domains/header/components/Header/Header.utils'
import { HeaderNavigationBusinessHow } from '@/src/domains/header/components/Header/HeaderNavigationBusinessHow'
import { HeaderNavigationBusinessSolution } from '@/src/domains/header/components/Header/HeaderNavigationBusinessSolution'
import { HeaderNavigationItem } from '@/src/domains/header/components/Header/HeaderNavigationItem'
import { HeaderNavigationOther } from '@/src/domains/header/components/Header/HeaderNavigationOther'
import { HeaderSupport } from '@/src/domains/header/components/Header/HeaderSupport'

import { HeaderDesktopNavigationButton } from './HeaderDesktopNavigationButton'
import { HeaderDesktopNavigationClinic } from './HeaderDesktopNavigationClinic'
import { HeaderDesktopNavigationContent } from './HeaderDesktopNavigationContent'
import { HeaderDesktopNavigationTherapists } from './HeaderDesktopNavigationTherapists'

const dropdownByContent: Record<HeaderMainNavigationContent, ComponentType> = {
  [HeaderMainNavigationContent.THERAPISTS]: HeaderDesktopNavigationTherapists,
  [HeaderMainNavigationContent.CLINIC]: HeaderDesktopNavigationClinic,
  [HeaderMainNavigationContent.OTHER]: HeaderNavigationOther,
  [HeaderMainNavigationContent.BUSINESS_HOW]: HeaderNavigationBusinessHow,
  [HeaderMainNavigationContent.BUSINESS_SOLUTION]: HeaderNavigationBusinessSolution,
}

export interface HeaderDesktopNavigationProps {
  menu: CMSMenuItem[]
  isBusiness?: boolean
}

export const HeaderDesktopNavigation = ({ menu, isBusiness = false }: HeaderDesktopNavigationProps) => {
  return (
    <NavigationMenu.Root className="hidden laptop:block">
      <NavigationMenu.List className="m-0 flex h-full list-none gap-2 p-0">
        {getHeaderMainNavigationItems(menu).map((item) => {
          if (item.href) {
            return (
              <HeaderNavigationItem key={item.id}>
                <HeaderDesktopNavigationButton href={item.href}>{item.title}</HeaderDesktopNavigationButton>
              </HeaderNavigationItem>
            )
          }

          const Dropdown = item.content ? dropdownByContent[item.content] : null

          return (
            <HeaderNavigationItem key={item.id}>
              <HeaderDesktopNavigationButton iconColor={isBusiness ? 'pink-600' : 'primary'}>
                {item.title}
              </HeaderDesktopNavigationButton>
              <HeaderDesktopNavigationContent>
                <Container width="xl" className="py-8">
                  {Dropdown ? <Dropdown /> : null}
                  <HeaderSupport />
                </Container>
              </HeaderDesktopNavigationContent>
            </HeaderNavigationItem>
          )
        })}
      </NavigationMenu.List>
      <div className="absolute left-0 right-0 top-[100%] flex max-h-[90vh] justify-center overflow-y-auto bg-white">
        <NavigationMenu.Viewport className="origin-top-center relative h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden border-0 border-solid border-sand-400 data-[state=open]:border-b-2 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90" />
      </div>
    </NavigationMenu.Root>
  )
}
